export default __webpack_public_path__ + "static/115-320f4e6d5030d2e65804fc834a1f55aa.jpg";